import { render } from "./UserLikedItemListPage.vue?vue&type=template&id=0bfbc70f"
import script from "./UserLikedItemListPage.vue?vue&type=script&lang=ts"
export * from "./UserLikedItemListPage.vue?vue&type=script&lang=ts"
script.render = render

export default script